<template lang="pug">
b-alert#invalids(show variant="danger" v-if="errors && errors.length > 0 && !isExpiration")
  span(v-if="isServer").
    {{ $t('error') }}
  span(v-else)
    span(v-if="title") {{ title }}
    span(v-else) {{ $t('shared.banner.error') }}
  ul
    li(v-for="(error, index) in errors" :key="index")
      a(v-if="error.html" @click="scrollToError(error)" v-html="error.msg")
      a(v-else @click="scrollToError(error)") {{ error.msg }}
</template>

<script>
export default {
  name: 'ErrorsBanner',
  props: {
    title: {type: String, default: undefined}
  },
  computed: {
    errors: {
      get () { return this.$store.state.errors.array.list }
    },
    isServer: {
      get () { return this.$store.state.errors.source === 'server' }
    },
    isExpiration: {
      get () { return this.$store.state.errors.source === 'expiration' }
    }
  },
  watch: {
    errors (n) {
      if (n && n.length > 0) {
        this.$nextTick(() => {
          let el = this.$root.$el.querySelector('#invalids')
          if (el) el.scrollIntoView()
        })
      }
    }
  },
  methods: {
    scrollToError (error) {
      this.$nextTick(() => {
        let el = this.$root.$el.querySelector(`[data-vv-id="${error.id}"]`)
        if (el) {
          el.scrollIntoView()
          el.focus()
        }
      })
    }
  }
}
</script>
